<template>
  <div>
    <div class="table-responsive col-lg-12">
      <aDataTable :data="sites">
        <template #columns>
          <tr>
            <th>Domainss</th>
            <th>Client</th>
            <th>Order</th>
            <th>Added</th>
            <th>Built</th>
            <th>Completed</th>
            <th>Builder</th>
            <th>Content</th>
            <th>Priority</th>
            <td>IP</td>
            <th>Deadline</th>
            <th style="width: 290px;">
              <div class="col-lg-1"><i v-tooltip="'Layout Ready'" class="fas fa-mountain"></i></div>
              <div class="col-lg-1"><i v-tooltip="'Demo Imported'" class="fas fa-file-import"></i></div>
              <div class="col-lg-1"><i v-tooltip="'Built'" class="fas fa-hammer"></i></div>
              <div class="col-lg-1"><i v-tooltip="'Content Ready'" class="fa fa-file"></i></div>
              <div class="col-lg-1"><i v-tooltip="'Content Added'" class="fas fa-file-upload"></i></div>
              <div class="col-lg-1"><i v-tooltip="'QA Passed'" class="fa fa-check"></i></div>
              <div class="col-lg-1"><i v-tooltip="'Moved to Production'" class="fa fa-arrow-right"></i></div>
              <div class="col-lg-1"><i v-tooltip="'Domain Moved to Client'" class="fas fa-people-arrows"></i></div>
              <div class="col-lg-1"><i class="fa fa-check" v-tooltip.top="'Delivered'"></i></div>
            </th>
          </tr>
        </template>
        <template #rows>
          <tr v-for="site in sites" :key="site.id">
            <td>
              <pbn :pbn="site"></pbn>
            </td>
            <td>{{ site.client ? site.client.name : '/' }}</td>
            <td>
              <e-txt
                v-if="site && site.client"
                :text="site.order ? site.order.name : '/'"
                :locked="!user.admin"
                type="select"
                :options="f.orders.filter(o => o.client && o.client.id === site.client.id).concat({id: null, name: '/'})"
                :selected-value="site.order ? site.order.id : null"
                :close-on-save="true"
                select-label="name"
                select-value="id"
                @input="patchPbn(site, 'order', $event)"
              ></e-txt>
            </td>
            <td><span v-if="site.buildActions['added']">{{ site.buildActions['built'].added | aTime }}</span></td>
            <td><span v-if="site.buildActions['built']">{{ site.buildActions['built'].endTime | aTime }}</span></td>
            <td><span v-if="site.buildActions['site-moved']">{{ site.buildActions['site-moved'].endTime | aTime }}</span></td>
            <td>
              <e-txt
                v-if="site.buildFlow"
                :text="site.buildActions['built'].assignee ? site.buildActions['built'].assignee.username : '/'"
                :locked="!user.admin"
                type="select"
                :options="builders"
                :selected-value="site.buildActions['built'].assignee ? site.buildActions['built'].assignee.id : null"
                :close-on-save="true"
                select-label="username"
                select-value="id"
                @input="setAssignee($event, 'built', site)"
              ></e-txt>
            <td>
            <e-txt
              v-if="site.buildFlow"
              :text="site.buildActions['content'].assignee ? site.buildActions['content'].assignee.username : '/'"
              :locked="!user.admin"
              type="select"
              :options="contenters"
              :selected-value="site.buildActions['content'].assignee ? site.buildActions['content'].assignee.id : null"
              :close-on-save="true"
              select-label="username"
              select-value="id"
              @input="setAssignee($event, 'content', site)"
            ></e-txt>
          </td>
            <td>
              <e-txt
                :locked="!user.admin"
                type="select"
                :options="[{label: 'High', index: 3},{label: 'Normal', index: 2},{label: 'Low', index: 1}]"
                select-label="label"
                select-value="index"
                :close-on-save="true"
                :selected-value="site.buildInfo.priority"
                :text="site.buildInfo.priority >= 3 ? 'High' : (site.buildInfo.priority === 2 ? 'Normal' : 'Low')"
                @input="patchPbn(site, 'buildInfo.priority', $event)"
              >
                <div class="label label-warning m-r-xs" v-if="site.buildInfo.priority == 3">High</div>
                <div class="label label-primary m-r-xs" v-if="site.buildInfo.priority == 2">Normal</div>
                <div class="label label-default m-r-xs" v-if="site.buildInfo.priority == 1">Low</div>
              </e-txt>
            </td>
            <td>
              <span
                v-if="site.integrations && site.integrations.hosting && site.integrations.hosting.ip"
                :class="site.dnsHostingMatches ? 'green' : 'red'"
              >
                <i class="fa fa-check green" v-if="site.dnsHostingMatches"></i>
                <i class="fa fa-remove red" v-else></i>
              {{ site.integrations.hosting.ip.ip_address}}
              </span>
              <span v-else class="orange">
                <span v-if="site.registrar && site.registrar.integration && site.registrar.integration.canUpdateRecords"><i class="fa fa-magic" title="DNS Records will be update through API once IP has been assigned"></i></span>
                <span v-else><i class="fas fa-hand-sparkles" title="DNS Records need to be set manually"></i></span>
              </span>
              <br>
              {{ site.registrar ? site.registrar.name : '/' }}
            </td>
            <td>{{ site.buildInfo.deadline ? $moment(site.buildInfo.deadline).fromNow()  : '/' }}</td>
            <td v-if="site.buildActions">
              <div class="col-lg-1">
                <action :action="site.buildActions['layout-ready']" :user="user"></action>
              </div>
              <div class="col-lg-1">
                <action :action="site.buildActions['demo-imported']" :user="user"></action>
              </div>
              <div :class="'col-lg-1 ' + getClass(site.buildActions.status)">
                <action :action="site.buildActions.built"></action>
              </div>
              <div class="col-lg-1">
                <action :action="site.buildActions.content"></action>
              </div>
              <div class="col-lg-1">
                <action :action="site.buildActions['content-added']"></action>
              </div>
              <div class="col-lg-1">
                <action :action="site.buildActions.qa"></action>
              </div>
              <div class="col-lg-1">
                <action :action="site.buildActions['site-moved']"></action>
              </div>
              <div class="col-lg-1">
                <action :action="site.buildActions['domain-moved']"></action>
              </div>
              <div class="col-lg-1">
                <action :action="site.buildActions.delivered"></action>
              </div>
            </td>
          </tr>
        </template>
      </aDataTable>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Action from './List/Actions'
import PbnListItem from '../PbnListItem'
import EditText from '../../../Helpers/Form/EditText'
import axios from 'axios'
import { eventBus } from '../../../../main'

export default {
  data () {
    return {
      builders: [],
      contenters: []
    }
  },
  computed: {
    ...mapGetters({
      sites: 'getPbns',
      user: 'getUser',
      f: 'getFilters'
    })
  },
  components: {
    action: Action,
    pbn: PbnListItem,
    eTxt: EditText
  },
  mounted () {
    if (!this.builders.length && this.user.admin) {
      this.loadWorkers()
    }
  },
  methods: {
    getClass (status) {
      return status === 'waiting' ? 'red' : status === 'started' ? 'yellow' : 'green'
    },
    loadWorkers () {
      axios.get('/users?operator=6163160e757197395775b0f2&roles=build,content').then(r => {
        this.builders = r.data.filter(u => u.roles.includes('build'))
        this.contenters = r.data.filter(u => u.roles.includes('content'))
      })
    },
    patchPbn (site, prop, val) {
      let data = {}
      data[prop] = val
      axios.patch(`/pbn/site/${site.punyDomain}`, data)
        .then(r => {
          this.$toastr.success(`${prop} successfully updated`)
          eventBus.$emit('searchBuilds')
        })
    },
    setAssignee (id, action, site) {
      let data = {
        action: action,
        assignee: id
      }
      axios.patch('/pbn/' + site.punyDomain + '/build/action', data).then(r => {
        this.$toastr.success('Worker successfully updated')
      }).catch(e => {
        this.$toastr.error(e, 'Not again...')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Build/List.vue